// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__IqSDy","title":"style_title__oqVKm","description":"style_description__UQYW+","retry":"style_retry__ojiY6"};